<!--
 * @Author: tony.zhu
 * @Date: 2025-10-11 15:01:54
 * @LastEditTime: 2025-10-15 12:00:15
 * @LastEditors: tony.zhu
 * @Description: 
-->

<template>
  <el-dropdown
    class="c-template_dropdown"
    :trigger="trigger"
    :placement="placement"
    v-bind="$attrs"
    ref="dropdownRef"
  >
    <template>
      <slot name="default"></slot>
    </template>
    <template #dropdown>
      <DropdownMenu v-bind="$attrs" v-on="$listeners">
        <div slot="custom" slot-scope="{ data }">
          <slot
            name="customItem"
            :data="data"
            :aliasData="data"
            :dropdownCustomItem="data"
          ></slot>
        </div>
      </DropdownMenu>
    </template>
  </el-dropdown>
</template>

<script>
import DropdownMenu from "./dropdownMenu.vue";
export default {
  name: "El-dropdown",
  components: {
    DropdownMenu,
  },
  props: {
    trigger: {
      type: String,
      default: "click",
    },
    placement: {
      type: String,
      default: "bottom-end",
    },
  },
};
</script>

<style lang="scss" scoped>

</style>